import React from 'react'
import styled from '@emotion/styled'

import theme from '../styles/theme'
import { em, rem, media } from '../styles/tools'
// import useScrolledBelow from '../hooks/useScrolledBelow'
// import { isBrowser } from '../utils'

import { Detail, DetailValue } from '../styles/typography'
import TextUnderline from './TextUnderline'

export const footerHeightBreakpoint = `@media (min-height: ${em(720)})`

export const ContentAboveFooter = styled('div')({
  position: 'relative',
  zIndex: 1,
  marginBottom: `calc(100vh - ${rem(theme.navbarHeight.mobile)})`,
  [footerHeightBreakpoint]: {
    marginBottom: '70vh',
  },
})

export const FooterContent = styled.footer({
  display: 'flex',
  alignItems: 'center',
  height: `calc(100vh - ${rem(theme.navbarHeight.mobile)})`,
  [footerHeightBreakpoint]: {
    height: '70vh',
  },
  position: 'fixed',
  right: theme.barWidth.mobile,
  left: theme.barWidth.mobile,
  bottom: 0,

  [media.laptop]: {
    right: theme.barWidth.laptop,
    left: theme.barWidth.laptop,
  },
})

export const DecideWhenToShowFooter = ({ children }) => {
  // const isBelow = useScrolledBelow(() =>
  //   isBrowser
  //     ? document.documentElement.scrollHeight - window.innerHeight * 2
  //     : 0
  // )

  // return isBelow ? children : null
  return children
}

export const FooterData = ({ short, ...props }) => (
  <ul
    css={{
      display: 'flex',
      flexDirection: 'column',
      '> li + li': { marginTop: rem(15) },
    }}
    {...props}
  >
    {!short && (
      <li>
        <Detail muted>WHO WE ARE:</Detail>
        <br />
        <DetailValue style={{ display: 'inline-block', maxWidth: '13em' }}>
          Based in Los Angeles, Ad&nbsp;Victorem is a&nbsp;competitive branding
          and marketing agency that combines award-winning creativity and
          business strategy for those who dare to win.
        </DetailValue>
      </li>
    )}
    <li>
      <Detail muted>GET IN TOUCH:</Detail>
      <br />
      <a href="tel:+03234573899">
        <TextUnderline color="rgba(255, 255, 255, .25)">
          <DetailValue>323.457.3899</DetailValue>
        </TextUnderline>
      </a>
    </li>
    <li>
      <Detail muted>Business Inquiries:</Detail>
      <br />
      <a href="mailto:hello@advictorem.agency">
        <TextUnderline color="rgba(255, 255, 255, .25)">
          <DetailValue>hello@advictorem.agency</DetailValue>
        </TextUnderline>
      </a>
    </li>
    <li>
      <Detail muted>JOIN OUR TEAM:</Detail>
      <br />
      <a href="mailto:jobs@advictorem.agency">
        <TextUnderline color="rgba(255, 255, 255, .25)">
          <DetailValue>jobs@advictorem.agency</DetailValue>
        </TextUnderline>
      </a>
    </li>
  </ul>
)
